import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ErrorModel } from 'src/app/core/models/error.model';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { FavoritoService } from 'src/app/main/favorite/services/favorito.service';
import { PageEvent as PageEventPipefy } from 'src/app/main/pipe-pagination/pipe-pagination.component';
import { PageEvent } from '@angular/material/paginator';
import { FavoritoModel } from 'src/app/main/hao/models/favorito.model';
import { HaoModel } from 'src/app/main/hao/models/hao.model';
import { HaoService } from 'src/app/main/hao/services/hao.service';
import { SharedService } from 'src/app/main/consultor/services/shared.service';
import { SharedModel } from 'src/app/main/consultor/models/shared.model';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'favorito', 'shared', 'codigo', 'criado_em', 'atualizado_em', 'consultor',
    'empresa', 'conexao', 'descricao_vaga', 'ponto', 'observacao'
  ];
  loading = false;
  dataSource = new MatTableDataSource<HaoModel>();
  pageSize = 10;
  length = 10;
  pageRanger = [10, 20, 50];
  allFavorite: FavoritoModel[] = [];
  pageFirst = 0;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
      private haoService: HaoService,
      private dialogService: DialogService,
      private favoritoService: FavoritoService,
      private router: Router,
      private sanitizer: DomSanitizer,
      private sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.getAllFavorite();
    // this.loadHaoFromPipefy('', '', this.pageSize);
    // this.loadHaoFromDb(this.pageFirst, this.length, 'id_hao', 'desc');
  }

  ngAfterViewInit(): void {
    this.loadHaoFromDb(this.pageFirst, this.length, 'codigo', 'desc');

    this.sort.sortChange.subscribe((s) => {
      this.loadHaoFromDb(this.pageFirst, this.length, s.active, s.direction);
    });
  }

  sanitize(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  private loadHaoFromPipefy(after: string, before: string, pageSize: number): void {
    this.loading = true;
    this.haoService.getHaoFromPipefy(after, before, pageSize).subscribe(result => {
      this.dataSource.data = result;
    }, (error: ErrorModel) => {
          const msgErro = 'Erro ao carregar dados do servidor';
          this.dialogService.showAlert(msgErro);
    }).add(() => {
      this.loading = false;
    });
  }

  private loadHaoFromDb(page: any, size: any, active: any, direction: any): void {
    this.loading = true;
    this.haoService.getHaoFromDb(page, size, active, direction).subscribe(result => {
      this.dataSource.data = result.content;
      this.length = result.totalElements;
    }, (error: ErrorModel) => {
      const msgErro = 'Erro ao carregar dados do servidor';
      this.dialogService.showAlert(msgErro);
    }).add(() => {
      this.loading = false;
    });
  }

  changePage(e: PageEvent): void {
    this.loadHaoFromDb(e.pageIndex, e.pageSize, this.sort.active, this.sort.direction);
  }

  pageEvent(e: PageEventPipefy): void {
    this.loading = e.loading;
    this.loadHaoFromPipefy((e.forward) ? e.startCursor : '', (e.back) ? e.endCursor : '', e.pageSize);
  }

  removeFavorito(codigo: string): void {
    this.favoritoService.remove(Number(codigo)).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  addFavorito(codigo: string, pipeId: any): void {
    this.favoritoService.add({cardId: codigo, pipeId}).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  private getAllFavorite(): void {
    this.favoritoService.getAllHao().subscribe(favorite => {
      this.allFavorite = favorite;
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  clickNavigation(s: string): any {
    return this.router.navigate([s]);
  }

  addShared(cardId: number, pipeId: number, consultor: string): void {
    this.sharedService.add({cardId, pipeId, consultor}).subscribe((result: SharedModel[]) => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  removeShared(cardId: number): void {
    this.sharedService.remove(Number(cardId)).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

}
